import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/views/Login.vue";
import LoginWithToken from "@/views/LoginWithToken.vue";
import ForgotPassword from "@/views/ForgotPassword.vue";
import Links from "@/views/Links.vue";
import LinkRedirect from "@/views/LinkRedirect.vue";
import FirmSearch from "@/views/FirmSearch.vue";
import UserSearch from "@/views/UserSearch.vue";
import UserEdit from "@/views/UserEdit.vue";
// *** Michal addenew page UserAdd.vue 
import UserAdd from "@/views/UserAdd.vue";
import ImportUsers from "@/views/ImportUsers.vue";
import Reports from "@/views/Reports.vue";

import axios from "axios"

Vue.use(VueRouter);

function loggedInRedirectLinks(to, from, next) {
  if (isTokenValid()) {
    axios
      .get("/auth")
      .then(() => {
        next('/links');
      })
      .catch(() => {
        next();
      });
  } else {
    next();
  }
}

function isLoggedIn(to, from, next) {
  if (isTokenValid()) {
    axios
      .get("/auth")
      .then(() => {
        next();
      })
      .catch(() => {
        next('/');
      });
  } else {
    next('/');
  }
}

// Change this to a promise so that it can be awaited
function isTokenValid() {
  // If no token in local storage return false
  if (!localStorage.token) {
    return false;
  }

  // If we get here there is a token, set the axios default authorization to the token
  axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem('token');

  return true;
}

const routes = [{
    path: "/",
    name: "Login",
    component: Login,
    beforeEnter: loggedInRedirectLinks
  },
  {
    path: "/loginwithtoken/:id",
    name: "LoginWithToken",
    component: LoginWithToken
  },
  {
    path: "/forgotpassword",
    name: "ForgotPassword",
    component: ForgotPassword
  },
  {
    path: "/links",
    name: "Links",
    component: Links,
    beforeEnter: isLoggedIn
  },
  {
    path: "/linkredirect",
    name: "LinkRedirect",
    component: LinkRedirect,
    beforeEnter: isLoggedIn
  },
  {
    path: "/firmsearch",
    name: "FirmSearch",
    component: FirmSearch,
    beforeEnter: isLoggedIn
  },
  {
    path: "/usersearch",
    name: "UserSearch",
    component: UserSearch,
    beforeEnter: isLoggedIn
  },
  {
    path: "/useredit",
    name: "UserEdit",
    component: UserEdit,
    beforeEnter: isLoggedIn
  },
  // *** Michal add link to new page UserAdd.vue
  {
    path: "/useradd",
    name: "UserAdd",
    component: UserAdd,
    beforeEnter: isLoggedIn
  },
  {
    path: "/importusers",
    name: "ImportUsers",
    component: ImportUsers,
    beforeEnter: isLoggedIn
  },
  {
    path: "/reports",
    name: "Reports",
    component: Reports,
    beforeEnter: isLoggedIn
  }  
];

const router = new VueRouter({
  routes
});

export default router;